import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { exportPdfList, exportPdf as _exportPdf } from 'api/tool/message';
export default {
  data: function data() {
    return {
      visible: false,
      disabled: false,
      form: {
        msg_id: '',
        page: 1,
        page_size: 10
      },
      total: 0,
      tableList: [],
      ids: '',
      tableLoading: false,
      tableRadio: null
    };
  },
  methods: {
    init: function init(item) {
      this.visible = true;
      this.form.msg_id = item.id;
      this.getTableList();
    },
    getTableList: function getTableList() {
      var _this = this;
      this.tableLoading = true;
      exportPdfList(this.form).then(function (res) {
        _this.tableList = res.data.items;
        _this.total = Number(res.data.pagination.total_count);
        _this.form.page = Number(res.data.pagination.current_page);
      }).finally(function () {
        return _this.tableLoading = false;
      });
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getTableList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val.id;
    },
    exportPdf: function exportPdf() {
      var _this2 = this;
      this.disabled = true;
      _exportPdf({
        msg_id: this.form.msg_id,
        ids: this.ids
      }).then(function (res) {
        if (res && res.code === 1) window.location.href = res.data.object_url;
      }).finally(function () {
        return _this2.disabled = false;
      });
    }
  }
};